<!-- 题库选购 -->
<template>
<div class="choose">
    <img :src="require('@/common/images/specialTopic/choose/banner.jpg')" class="banner" />
    <div class="choose-content container">
        <div class="topic-item" v-for="(option) in list" :key="option.examcode">
            <div class="title">{{ option.topicname }}</div>
            <div class="list-box">
                <div class="item pointer" @click="handleOpenSubjectDetails(option, item)" v-for="(item) in option.subject" :key="item.subjectcode">
                    <img class="subject-banner" :src="item.banner" />
                    <div class="text-info">
                        <div class="subject-name">{{ item.showLabel }}</div>
                        <div class="uprice">￥{{ item.uprice }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getTopicQBBaseInfoAll} from '@/api/specialTopic.js'
import specialTopic from '@/common/js/specialTopic.json'
import subjectBanner1 from '@/common/images/mSpecialTopic/choose/subject_banner1.png'
import subjectBanner2 from '@/common/images/mSpecialTopic/choose/subject_banner2.png'
import subjectBanner3 from '@/common/images/mSpecialTopic/choose/subject_banner3.png'
import subjectBanner4 from '@/common/images/mSpecialTopic/choose/subject_banner4.png'
import subjectBanner5 from '@/common/images/mSpecialTopic/choose/subject_banner5.png'
import subjectBanner6 from '@/common/images/mSpecialTopic/choose/subject_banner6.png'
import subjectBanner7 from '@/common/images/mSpecialTopic/choose/subject_banner7.png'
import subjectBanner8 from '@/common/images/mSpecialTopic/choose/subject_banner8.png'
import subjectBanner9 from '@/common/images/mSpecialTopic/choose/subject_banner9.png'
import subjectBanner10 from '@/common/images/mSpecialTopic/choose/subject_banner10.png'
import subjectBanner11 from '@/common/images/mSpecialTopic/choose/subject_banner11.png'
import subjectBanner12 from '@/common/images/mSpecialTopic/choose/subject_banner12.png'
import subjectBanner13 from '@/common/images/mSpecialTopic/choose/subject_banner13.png'
import subjectBanner14 from '@/common/images/mSpecialTopic/choose/subject_banner14.png'
import subjectBanner15 from '@/common/images/mSpecialTopic/choose/subject_banner15.png'
import subjectBanner16 from '@/common/images/mSpecialTopic/choose/subject_banner16.png'
export default {
    data() {
        return {
            subjectlist: [],
            list: [],
            subjectBanner1,
            subjectBanner2,
            subjectBanner3,
            subjectBanner4,
            subjectBanner5,
            subjectBanner6,
            subjectBanner7,
            subjectBanner8,
            subjectBanner9,
            subjectBanner10,
            subjectBanner11,
            subjectBanner12,
            subjectBanner13,
            subjectBanner14,
            subjectBanner15,
            subjectBanner16,
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if(this.domainInfo.isMobile){
            this.$router.push({
                name: 'MSpecialChoose'
            })
        }
        this.subjectlist = JSON.parse(JSON.stringify(specialTopic.buySubjectList))
        this.handleGetTopicQBBaseInfoAll()
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleGetTopicQBBaseInfoAll() {
            this.setLoading(true)
            getTopicQBBaseInfoAll({
                data: {},
                success: data => {
                    data.data.forEach((item, index) => {
                        if (item.examcode === 'jjcy') {
                            item.topicname = '基金从业题库'
                        } else if (item.examcode === 'zqcy') {
                            item.topicname = '证券从业题库'
                        } else if (item.examcode === 'qhcy') {
                            item.topicname = '期货从业题库'
                        }
                        let subject = []
                        this.subjectlist.some(option => {
                            if (option.examcode === item.examcode) {
                                subject = JSON.parse(JSON.stringify(option.subjectList))
					            return true
                            }
                        })
                        subject.forEach(option => {
                            option.uprice = item[option.upricename]
                            option.banner = this[option.bannername]
                        })
                        item.subject = subject
                    })
                    this.list = data.data
                    this.setLoading(false)
                },
                error: error => {
                    this.setLoading(false)
                    this.$toast.fail(error.msg)
                }
            })
        },
        handleOpenSubjectDetails(option, item) {
            localStorage.setItem('topicItem', JSON.stringify(Object.assign({}, item, {examcode: option.examcode})))
            this.$router.push({
                name: 'SpecialTopicDetails',
                params: {
                    examcode: option.examcode
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        ...mapGetters(['domainInfo'])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.choose {
    min-height: calc(100vh - 75px);
    background: #fff;
    .banner {
        width: 100%;
        height: auto;
        min-width: 1200px;
    }
    .choose-content {
        padding: 40px 0;
        .title {
            font-size: 24px;
            color: #333333;
            line-height: 34px;
            text-align: center;
            margin-bottom: 40px;
        }
        .list-box {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .item {
                width: 288px;
                height: 251px;
                background: #FFFFFF;
                box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.2);
                border-radius: 10px 10px 10px 10px;
                margin-bottom: 28px;
                border-radius: 10px 10px 10px 10px;
                &:not(:nth-of-type(4n)) {
                    margin-right: 16px;
                }
                .subject-banner {
                    width: 288px;
                    height: 162px;
                    border-radius: 10px 10px 0 0;
                }
                .text-info {
                    padding: 15px;
                    .subject-name {
                        font-size: 18px;
                        color: #333333;
                        line-height: 25px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-weight: bold;
                        margin-bottom: 6px;
                    }
                    .uprice {
                        font-size: 20px;
                        color: #FA2B19;
                        line-height: 28px;
                    }
                }
            }
        }
    }
}
</style>